'use strict';
//poiRow
export default class PoiRowComponent {
  constructor() {
    this.restrict = 'A'
    this.template = require('./poi.tablerow.component.html');
    this.scope = {
      poi: '=',
      username: '='
    };
    this.controller = PoiRowComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

/* @ngInject */
class PoiRowComponentController {
  constructor() {
  }
}